import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

// Configuration de base pour l'API
const API_URL = process.env.REACT_APP_API_URL || 
  `${process.env.REACT_APP_WORDPRESS_URL}/wp-json`;

const WC_CONSUMER_KEY = process.env.REACT_APP_WC_CONSUMER_KEY || '';
const WC_CONSUMER_SECRET = process.env.REACT_APP_WC_CONSUMER_SECRET || '';
const WC_API_VERSION = process.env.REACT_APP_WC_API_VERSION || 'wc/v3';

// Créer une instance Axios configurée
export const api: AxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter l'authentification
api.interceptors.request.use((config) => {
  // Ajouter les paramètres d'authentification OAuth 1.0
  if (config.url?.includes('/wc/')) {
    config.params = {
      ...config.params,
      consumer_key: WC_CONSUMER_KEY,
      consumer_secret: WC_CONSUMER_SECRET,
    };
  }
  return config;
});

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Erreur de la réponse du serveur
      console.error('Erreur API:', error.response.data);
      
      // Gérer les erreurs spécifiques
      switch (error.response.status) {
        case 401:
          // Non autorisé - vérifier les clés API
          console.error('Erreur d\'authentification. Vérifiez vos clés API WooCommerce.');
          break;
        case 404:
          console.error('Ressource non trouvée.');
          break;
        case 500:
          console.error('Erreur serveur.');
          break;
      }
    } else if (error.request) {
      // La requête a été faite mais pas de réponse
      console.error('Pas de réponse du serveur:', error.request);
    } else {
      // Erreur lors de la configuration de la requête
      console.error('Erreur de configuration:', error.message);
    }
    
    return Promise.reject(error);
  }
);

// Fonctions utilitaires pour les requêtes
export const apiRequest = {
  get: <T>(url: string, config?: AxiosRequestConfig) => 
    api.get<T>(url, config).then(response => response.data),
    
  post: <T>(url: string, data?: any, config?: AxiosRequestConfig) => 
    api.post<T>(url, data, config).then(response => response.data),
    
  put: <T>(url: string, data?: any, config?: AxiosRequestConfig) => 
    api.put<T>(url, data, config).then(response => response.data),
    
  delete: <T>(url: string, config?: AxiosRequestConfig) => 
    api.delete<T>(url, config).then(response => response.data),
};

// Fonction pour construire les URLs de l'API WooCommerce
export const buildWcUrl = (endpoint: string): string => {
  return `/${WC_API_VERSION}/${endpoint}`;
};

// Fonction pour gérer la pagination
export interface PaginationHeaders {
  total: number;
  totalPages: number;
  page: number;
  perPage: number;
}

export const getPaginationFromHeaders = (headers: any): PaginationHeaders => {
  return {
    total: parseInt(headers['x-wp-total'] || '0'),
    totalPages: parseInt(headers['x-wp-totalpages'] || '0'),
    page: parseInt(headers['x-wp-page'] || '1'),
    perPage: parseInt(headers['x-wp-per-page'] || '10'),
  };
};

// Export de la configuration pour les tests
export const getApiConfig = () => ({
  apiUrl: API_URL,
  consumerKey: WC_CONSUMER_KEY,
  consumerSecret: WC_CONSUMER_SECRET,
  wcVersion: WC_API_VERSION,
});

